export const shippingLocationModel = ({
                                          name,
                                          address,
                                          address2,
                                          city,
                                          shippingLocationId,
                                          state = `FL`,
                                          zipcode,
                                          isEnabled,
                                          isSchoolAddress,
                                      }: Record<string, any> = {}) => ({
    name,
    address,
    address2,
    city,
    shippingLocationId,
    state,
    zipcode,
    isEnabled,
    isSchoolAddress,

});